module.exports = __webpack_public_path__ + "static/media/yardnapa-bg.aac418fe.png";